<template>
    <div class="list" :style="{height:wrapperHeight + 'px'}">
        <div class="container wrapper" ref="wrapper">
            <div class="card let-space-1" v-if="getCompanys.length != 0">
                <ul class="list-group list-group-flush border-bottom-0">
                    <template v-if="getCurrentCompany">
                        <li class="list-group-item py-1 bg-light">現在選択</li>
                        <li class="list-group-item px-2 pb-1" @click="toInviteCode(currentId,currentGroup,currentName)">
                            <div><span v-if="currentId">({{currentId}})</span> {{this.currentName}} </div>
                            <div class="text-muted">
                                <small>
                                    <span class="border px-1">{{this.currentGroup}}</span>
                                </small>
                            </div>
                        </li>
                    </template>
                    <template v-if="getCompanys.length != 0">
                        <li class="list-group-item py-1 bg-light">すべて</li>
                        <li class="list-group-item px-2 pb-1" v-for="item in getCompanys" :key="item.id" @click="toInviteCode(item.id, item.user_group, item.name)">
                            <div>
                                <small class="d-flex">
                                    <span class="text-nowrap">
                                        <small>
                                            <i v-if="item.email_flg == '0'" class="fas fa-circle text-success"></i>
                                            <i v-else class="fas fa-circle text-danger"></i>&nbsp;
                                        </small>
                                        <i v-if="item.cnt > 0" class="fas fa-user text-success"></i>
                                        <i v-else  class="fas fa-user text-muted"></i>&nbsp;&nbsp;
                                    </span>
                                    <span>({{item.id}})&nbsp;</span>
                                    <span class="text-nowrap text-truncate"> {{item.name}} </span>
                                </small>
                            </div>
                            <div class="text-muted">
                                <small>
                                    <span>lv.{{item.email_lev}}</span>
                                    <span class="border px-1">{{item.user_group}}</span>
                                    <span v-if="item.country" class="border px-1">{{item.country}}</span>
                                    <span v-if="item.sales_name" class="border border-primary px-1">{{item.sales_name}}</span>
                                    <span v-if="item.sales_mail" class="border border-success px-1">to</span>
                                    <span v-if="item.sales_mail_cc" class="border border-success px-1">cc</span>
                                </small>
                            </div>
                        </li>
                    </template>
                </ul>
            </div>
            <!-- 0件メッセージ -->
            <not-found-msg v-else></not-found-msg>
        </div>
    </div>
</template>

<script>
    import NotFoundMsg from 'pages/commons/notFoundMsg/NotFoundMsg'
    import BScroll from 'better-scroll'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            NotFoundMsg
        },
        mounted () {
            this.scroll = new BScroll(this.$refs.wrapper, {click:true})
        },
        activated () {
            this.scroll = new BScroll(this.$refs.wrapper, {click:true})
        },
        computed: {
            wrapperHeight () {
                return $(window).height() - 192
            },
            from () {
                return this.$route.params.id
            },
            currentId () {
                return this.getCurrentCompany.split(" ")[0]
            },
            currentGroup () {
                return this.getCurrentCompany.split(" ")[1]
            },
            currentName () {
                return this.getCurrentCompany.split(" ")[2]
            },
            ...mapGetters(['getCompanys', 'getCurrentCompany'])
        },
        methods: {
            toInviteCode (id, group, name) {
                if (this.from == '0') {
                    this.$parent.toInviteCode(id, group, name)
                }
                if (this.from == '1') {
                    this.$parent.toInviteDetail(id, group, name)
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .list
        position: relative
        .wrapper
            overflow: hidden
            position: absolute
            top: 0.5rem
            left: 0
            right: 0
            bottom: 0rem
</style>
